import { Navigate, Outlet, useLocation } from 'react-router';
import { useMe } from '../api/auth';

export function RequireAuth() {
  const me = useMe();
  const loc = useLocation();
  if (me.isPending) return <div className="loading">Loading…</div>;
  if (me.isError) {
    const next = encodeURIComponent(loc.pathname + loc.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  return <Outlet />;
}
